import { ClipLoader, PropagateLoader, PulseLoader } from "react-spinners";

const LoaderSpinner = () => {
  return (
    <div className="loader">
      <PulseLoader color="#948256" size={15} />
    </div>
  );
};

export default LoaderSpinner;
